// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container___0qOj","fooDriver":"about_fooDriver__tC6rT","easyDonate":"about_easyDonate__1SpZc","easyRequest":"about_easyRequest__1fbAS"};